export default "__VITE_ASSET__CFJlEpfR__"